export const GET_EDIT_DATA = 'src/components/Corporate/Create/action/GET_EDIT_DATA';
export const GET_EDIT_DATA_SUCCESS = 'src/components/Corporate/Create/action/GET_EDIT_DATA_SUCCESS';
export const GET_EDIT_DATA_FAILURE = 'src/components/Corporate/Create/action/GET_EDIT_DATA_FAILURE';

export const getEditData = (data) => {
    return {
        type: GET_EDIT_DATA,
        data
    }
}
export const getEditDataSuccess = (data) => {
    return {
        type: GET_EDIT_DATA_SUCCESS,
        data
    }
}
export const getEditDataFailure = (data) => {
    return {
        type: GET_EDIT_DATA_FAILURE,
        data
    }
}

export const GET_STATES_LIST = 'src/components/Corporate/Create/action/GET_STATES_LIST';
export const GET_STATES_LIST_SUCCESS = 'src/components/Corporate/Create/action/GET_STATES_LIST_Success';
export const GET_STATES_LIST_FAILURE = 'src/components/Corporate/Create/action/GET_STATES_LIST_Failure';
export const SET_CORPORATE_ONBOARDING_STATUS = 'src/components/Corporate/Create/action/SET_CORPORATE_ONBOARDING_STATUS';
export const SET_COMPANY_SETUP = 'src/components/Corporate/Create/action/SET_COMPANY_SETUP';
export const getStatesList = () => {
    return {
        type: GET_STATES_LIST,
    }
}
export const getStatesListSuccess = (data) => {
    return {
        type: GET_STATES_LIST_SUCCESS,
        data
    }
}
export const getStatesListFailure = (data) => {
    return {
        type: GET_STATES_LIST_FAILURE,
        data
    }
}

export const setCompanySetup = (data) => {
    return {
        type: SET_COMPANY_SETUP,
        data
    }
}

export const setCorporateOnboardingStatus = (data) => {
    return {
        type: SET_CORPORATE_ONBOARDING_STATUS,
        data
    }
}

export const SET_PRODUCT_SETUP_DATA = 'src/components/Corporate/Create/action/Set_Product_Setup_Data';
export const setProductSetup = (data) => {
    return {
        type: SET_PRODUCT_SETUP_DATA,
        data
    }
}

export const FETCH_PRODUCT_SECTION_LIST = 'src/Admin/Corporate/Create/action/Fetch_Product_Section_List';
export const FETCH_PRODUCT_SECTION_LIST_SUCCESS = 'src/Admin/Corporate/Create/action/Fetch_Product_Section_List_Success';
export const FETCH_PRODUCT_SECTION_LIST_FAILURE = 'src/Admin/Corporate/Create/action/Fetch_Product_Section_List_Failure';

export const fetchSectionList = () => {
    return {
        type: FETCH_PRODUCT_SECTION_LIST
    }
}
export const fetchSectionListSuccess = (data) => {
    return {
        type: FETCH_PRODUCT_SECTION_LIST_SUCCESS,
        data
    }
}
export const fetchSectionListFailure = (data) => {
    return {
        type: FETCH_PRODUCT_SECTION_LIST_FAILURE,
        data
    }
}

export const FETCH_CREDIT_LIMIT_MODEL_LIST = 'src/Admin/Corporate/Create/action/Fetch_Credit_Limit_Model_List';
export const FETCH_CREDIT_LIMIT_MODEL_LIST_SUCCESS = 'src/Admin/Corporate/Create/action/Fetch_Credit_Limit_Model_List_Success';
export const FETCH_CREDIT_LIMIT_MODEL_LIST_FAILURE = 'src/Admin/Corporate/Create/action/Fetch_Credit_Limit_Model_List_Failure';

export const fetchCreditLimitModelList = () => {
    return {
        type: FETCH_CREDIT_LIMIT_MODEL_LIST
    }
}
export const fetchCreditLimitModelListSuccess = (data) => {
    return {
        type: FETCH_CREDIT_LIMIT_MODEL_LIST_SUCCESS,
        data
    }
}
export const fetchCreditLimitModelListFailure = (data) => {
    return {
        type: FETCH_CREDIT_LIMIT_MODEL_LIST_FAILURE,
        data
    }
}


export const DISABLE_PRODUCT = 'Disable_Product';
export const DISABLE_PRODUCT_SUCCESS = 'Disable_Product_Success';
export const DISABLE_PRODUCT_FAILURE = 'Disable_Product_Failure';

export const disableProduct = (data) => {
    return {
        type: DISABLE_PRODUCT,
        data
    }
}
export const disableProductSuccess = (data) => {
    return {
        type: DISABLE_PRODUCT_SUCCESS,
        data
    }
}
export const disableProductFailure = (data) => {
    return {
        type: DISABLE_PRODUCT_FAILURE,
        data
    }
}


/* export const FETCH_RISKGRADE_CATEGORY_LIST = 'src/Admin/Corporate/Create/action/Fetch_Riskgrade_Category_List';
export const FETCH_RISKGRADE_CATEGORY_LIST_SUCCESS = 'src/Admin/Corporate/Create/action/Fetch_Riskgrade_Category_List_Success';
export const FETCH_RISKGRADE_CATEGORY_LIST_FAILURE = 'src/Admin/Corporate/Create/action/Fetch_Riskgrade_Category_List_Failure';

export const fetchRiskgradeCategory = () => {
    return {
        type: FETCH_RISKGRADE_CATEGORY_LIST
    }
}
export const fetchRiskgradeCategorySuccess = (data) => {
    return {
        type: FETCH_RISKGRADE_CATEGORY_LIST_SUCCESS,
        data
    }
}
export const fetchRiskgradeCategoryFailure = (error) => {
    return {
        type: FETCH_RISKGRADE_CATEGORY_LIST_FAILURE,
        error
    }
} */

export const FETCH_RISKFACTORS = 'src/Admin/Corporate/Create/action/Fetch_Riskfactor';
export const FETCH_RISKFACTORS_SUCCESS = 'src/Admin/Corporate/Create/action/Fetch_Riskfactor_Success';
export const FETCH_RISKFACTORS_FAILURE = 'src/Admin/Corporate/Create/action/Fetch_Riskfactor_Failure';

export const fetchRiskfactors = (data) => {
    return {
        type: FETCH_RISKFACTORS,
        data
    }
}
export const fetchRiskfactorsSuccess = (data) => {
    return {
        type: FETCH_RISKFACTORS_SUCCESS,
        data
    }
}
export const fetchRiskfactorsFailure = (error) => {
    return {
        type: FETCH_RISKFACTORS_FAILURE,
        error
    }
}

export const CORPORATE_ONBOARDING = 'src/Admin/Corporate/Create/action/Corporate_Onboarding';
export const CORPORATE_ONBOARDING_SUCCESS = 'src/Admin/Corporate/Create/action/Corporate_Onboarding_Success';
export const CORPORATE_ONBOARDING_FAILURE = 'src/Admin/Corporate/Create/action/Corporate_Onboarding_Failure';

export const CorporateOnboarding = (data) => {
    return {
        type: CORPORATE_ONBOARDING,
        data
    }
}
export const CorporateOnboardingSuccess = (data) => {
    return {
        type: CORPORATE_ONBOARDING_SUCCESS,
        data
    }
}
export const CorporateOnboardingFailure = (error) => {
    return {
        type: CORPORATE_ONBOARDING_FAILURE,
        error
    }
}

export const SAVE_SCORECARD_DATA = 'src/Admin/Corporate/Create/action/Save_Scorecard_Data';
export const saveScorecardData = (data) => {
    return {
        type: SAVE_SCORECARD_DATA,
        data
    }
}

export const CORPORATE_ONBOARDING_EDIT = 'src/Admin/Corporate/Create/action/Corporate_Onboarding_Edit';
export const CORPORATE_ONBOARDING_EDIT_SUCCESS = 'src/Admin/Corporate/Create/action/Corporate_Onboarding_Edit_Success';
export const CORPORATE_ONBOARDING_EDIT_FAILURE = 'src/Admin/Corporate/Create/action/Corporate_Onboarding_Edit_Failure';

export const corporateOnboardingEdit = (data) => {
    return {
        type: CORPORATE_ONBOARDING_EDIT,
        data
    }
}
export const corporateOnboardingEditSuccess = (data) => {
    return {
        type: CORPORATE_ONBOARDING_EDIT_SUCCESS,
        data
    }
}
export const corporateOnboardingEditFailure = (error) => {
    return {
        type: CORPORATE_ONBOARDING_EDIT_FAILURE,
        error
    }
}

export const ONE_CLICK_CORPORATE_ONBOARDING = 'src/Admin/Corporate/Create/action/One_Click_Corporate_Onboarding';
export const ONE_CLICK_CORPORATE_ONBOARDING_SUCCESS = 'src/Admin/Corporate/Create/action/One_Click_Corporate_Onboarding_Success';
export const ONE_CLICK_CORPORATE_ONBOARDING_FAILURE = 'src/Admin/Corporate/Create/action/One_Click_Corporate_Onboarding_Failure';

export const oneClickCorporateOnboarding = (data) => {
    return {
        type: ONE_CLICK_CORPORATE_ONBOARDING,
        data
    }
}
export const oneClickCorporateOnboardingSuccess = (data) => {
    return {
        type: ONE_CLICK_CORPORATE_ONBOARDING_SUCCESS,
        data
    }
}
export const oneClickCorporateOnboardingFailure = (error) => {
    return {
        type: ONE_CLICK_CORPORATE_ONBOARDING_FAILURE,
        error
    }
}

export const ADD_DEFAULT_PRODUCTS = 'src/Admin/Corporate/Create/action/Add_Default_Products';
export const ADD_DEFAULT_PRODUCTS_SUCCESS = 'src/Admin/Corporate/Create/action/Add_Default_Products_Success';
export const ADD_DEFAULT_PRODUCTS_FAILURE = 'src/Admin/Corporate/Create/action/Add_Default_Products_Failure';

export const addDefaultProducts = (data) => {
    return {
        type: ADD_DEFAULT_PRODUCTS,
        data
    }
}
export const addDefaultProductsSuccess = (data) => {
    return {
        type: ADD_DEFAULT_PRODUCTS_SUCCESS,
        data
    }
}
export const addDefaultProductsFailure = (error) => {
    return {
        type: ADD_DEFAULT_PRODUCTS_FAILURE,
        error
    }
}


export const SET_CREDIT_SETUP = 'src/Admin/Corporate/Create/action/Set_Credit_Setup';
export const setCreditSetup = (data) => {
    return {
        type: SET_CREDIT_SETUP,
        data
    }
}


export const FETCH_MIS_FIELDS = 'src/Admin/Corporate/Create/action/Fetch_Mis_Fields';
export const FETCH_MIS_FIELDS_SUCCESS = 'src/Admin/Corporate/Create/action/Fetch_Mis_Fields_Success';
export const FETCH_MIS_FIELDS_FAILURE = 'src/Admin/Corporate/Create/action/Fetch_Mis_Fields_Failure';
export const SET_MIS_FIELD_SETUP_DATA = 'src/Admin/Corporate/Create/action/Set_Mis_Field_Setup_Data';
export const SET_MIS_FIELDS = 'src/Admin/Corporate/Create/action/Set_Mis_Fields';
export const FETCH_MIS_FIELDS_BY_CORPORATE_ID = 'src/Admin/Corporate/Create/action/Fetch_Mis_Fields_By_Corporate_Id';
export const FETCH_MIS_FIELDS_BY_CORPORATE_ID_FAILURE = 'src/Admin/Corporate/Create/action/Fetch_Mis_Fields_By_Corporate_Id_Failure';

export const fetchMisFields = (data) => {
    return {
        type: FETCH_MIS_FIELDS,
        data
    }
}
export const setMisFields = (data) => {
    return {
        type: SET_MIS_FIELDS,
        data
    }
}
export const fetchMisFieldsSuccess = (data) => {
    return {
        type: FETCH_MIS_FIELDS_SUCCESS,
        data
    }
}
export const fetchMisFieldsFailure = (error) => {
    return {
        type: FETCH_MIS_FIELDS_FAILURE,
        error
    }
}

export const setMisFieldSetup = (data) => {
    return {
        type: SET_MIS_FIELD_SETUP_DATA,
        data
    }
}


export const fetchMisFieldsByCorporateId = (data) => {
    return {
        type: FETCH_MIS_FIELDS_BY_CORPORATE_ID,
        data
    }
}


export const fetchMisFieldsByCorporateIdFailure = (data) => {
    return {
        type: FETCH_MIS_FIELDS_BY_CORPORATE_ID_FAILURE,
        data
    }
}

export const SET_IS_MANDATORY_MIS_ORDERID_SETUP_DATA = 'src/Admin/Corporate/Create/action/Set_Is_Mandatory_Mis_OrderId_Setup_Data';
export const FETCH_IS_MANDATORY_MIS_ORDERID_BY_CORPORATE = 'src/Admin/Corporate/Create/action/Fetch_Is_Mandatory_Mis_OrderId_By_Corporate';
export const FETCH_IS_MANDATORY_MIS_ORDERID_BY_CORPORATE_SUCCESS = 'src/Admin/Corporate/Create/action/Fetch_Is_Mandatory_Mis_OrderId_By_Corporate_Success';
export const FETCH_IS_MANDATORY_MIS_ORDERID_BY_CORPORATE_FAILURE = 'src/Admin/Corporate/Create/action/Fetch_Is_Mandatory_Mis_OrderId_By_Corporate_Filure';


export const setIsMandatoryMisOrderId = (data) => {
    return {
        type: SET_IS_MANDATORY_MIS_ORDERID_SETUP_DATA,
        data
    }
}

export const fetchIsMisOrderIdMandatoryByCorporateId = (data) => {
    return {
        type: FETCH_IS_MANDATORY_MIS_ORDERID_BY_CORPORATE,
        data
    }
}
export const fetchIsMisOrderIdMandatoryByCorporateIdSuccess = (data) => {
    return {
        type: FETCH_IS_MANDATORY_MIS_ORDERID_BY_CORPORATE_SUCCESS,
        data
    }
}
export const fetchIsMisOrderIdMandatoryByCorporateIdFailure = (error) => {
    return {
        type: FETCH_IS_MANDATORY_MIS_ORDERID_BY_CORPORATE_FAILURE,
        error
    }
}

export const FETCH_DEFAULT_MIS_FIELDS = 'src/Admin/Corporate/Create/action/Fetch_Default_Mis_Fields';
export const FETCH_DEFAULT_MIS_FIELDS_SUCCESS = 'src/Admin/Corporate/Create/action/Fetch_Default_Mis_Fields_Success';
export const FETCH_DEFAULT_MIS_FIELDS_FAILURE = 'src/Admin/Corporate/Create/action/Fetch_Default_Mis_Fields_Failure';
export const SET_DEFAULT_MIS_FIELDS = 'src/Admin/Corporate/Create/action/Set_Default_Mis_Fields';
export const fetchDefaultMisFields = (data) => {
    return {
        type: FETCH_DEFAULT_MIS_FIELDS,
        data
    }
}
export const setDefaultMisFields = (data) => {
    return {
        type: SET_DEFAULT_MIS_FIELDS,
        data
    }
}
export const fetchDefaultMisFieldsSuccess = (data) => {
    return {
        type: FETCH_DEFAULT_MIS_FIELDS_SUCCESS,
        data
    }
}
export const fetchDefaultMisFieldsFailure = (error) => {
    return {
        type: FETCH_DEFAULT_MIS_FIELDS_FAILURE,
        error
    }
}


export const FETCH_EWS_PLAN_NAME_LIST = 'src/Admin/Corporate/Create/action/Fetch_Ews_Plan_Name_List';
export const FETCH_EWS_PLAN_NAME_LIST_SUCCESS = 'src/Admin/Corporate/Create/action/Fetch_Ews_Plan_Name_List_Success';
export const FETCH_EWS_PLAN_NAME_LIST_FAILURE = 'src/Admin/Corporate/Create/action/Fetch_Ews_Plan_Name_List_Failure';


export const fetchEwsSelectPlanName = (data) => {
    return {
        type: FETCH_EWS_PLAN_NAME_LIST,
        data
    }
}
export const fetchEwsSelectPlanNameSuccess = (data) => {
    return {
        type: FETCH_EWS_PLAN_NAME_LIST_SUCCESS,
        data
    }
}
export const fetchEwsSelectPlanNameFailure = (error) => {
    return {
        type: FETCH_EWS_PLAN_NAME_LIST_FAILURE,
        error
    }
}